import styled, { css } from "styled-components";

import {
  flex,
  drawDebug,
  breakpoints
} from "../helpers";
import {
  withBreakpoints,
  HedronProviderProps
} from "./Provider";
import Base from "./Base";

export interface HedronBoxProps extends HedronProviderProps {
  // Debug Properties
  debug?: boolean;
  // Flex-specific Properties
  flex?: boolean;
  fill?: boolean;
  fluid?: boolean;
  shiftRight?: boolean;
  shiftLeft?: boolean;
  shiftUp?: boolean;
  shiftDown?: boolean;
}

export const Box = styled(Base("div"))<HedronBoxProps>`
  box-sizing: border-box;
  ${props => css`
    ${props.fluid && "padding: 0;"}
    ${props.debug && drawDebug()};
    ${flex(props)};
    ${breakpoints(props)};
  `}
`;

Box.defaultProps = {
  debug: false,
  fill: false,
  //@ts-ignore
  ...Base.defaultProps
};

export default withBreakpoints(Box);
